export default class ItemsSupplierOrder {
    constructor() {
        this.id = "";
        this.typeProduct = { id: "", content: "" };
        this.productFullName = "";
        this.product = { id: "", content: "" };
        this.productId = "";
        this.description = "";
        this.quantity = 1;
        this.unitValue = 0;
        this.supplierOrderId = "";
    }
    update(data) {
        this.id = data.id;
        this.typeProduct = { id: data.typeProductId, content: data.typeProductName };
        this.product = { id: data.productId, content: data.productName };
        this.description = data.description;
        this.quantity = data.quantity;
        this.unitValue = data.unitValue;
        this.supplierOrderId = data.supplierOrderId;
    }
}